/** @jsxImportSource @emotion/react */
import { memo } from "react";
import PropTypes from "prop-types";
import actionButtonCss from "assets/css/actionButton.css";
import { ReactComponent as CloseIcon } from "assets/icons/Close.svg";
import { closeButtonCss } from "assets/css/modal.css";
import { headerCss } from "./index.css";

function ModalHeader({ children, handleClose }) {
  return (
    <>
      <p css={headerCss} className="main-title">
        {children}
      </p>

      <div css={closeButtonCss}>
        <button type="button" css={actionButtonCss} onClick={handleClose}>
          <CloseIcon />
        </button>
      </div>
    </>
  );
}

ModalHeader.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  handleClose: PropTypes.func.isRequired,
};

export default memo(ModalHeader);
